import { PaymentMode } from "./payment-modes.model";
import { Sale, SaleForm } from "./sales.model";

export class Recovery extends Sale {

	reference: string;
	amountDue: number;
	amount: number;
	observation: string;
	paymentMode: PaymentMode;

	constructor() {
		super();
		this.paymentMode = new PaymentMode();
	}
}

export class RecoveryForm extends SaleForm {

	reference: string;
	amountDue: number;
	amount: number;
	observation: string;
	paymentMode: number;

	constructor() { 
		super();
	}
}